﻿/// <reference path="../@types/alertify/index.d.ts" />
import { SaopAbsenceConfirmationPendingView } from "../AbsenceConfirmation/saop-absenceConfirmation-pending-view";
import { global } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import { SaopMessageBanner } from '../Components/saop-message-banner';

export class DashboardAbsenceConfirmationView {
    private _libName:string;
    private _saopServicesCore: SaopServicesCore;
    private absenceConfirmationPendingView: SaopAbsenceConfirmationPendingView;
    private saopMessageBanner: SaopMessageBanner;
    //

    constructor(libName: string = "") {
        this._libName = libName;
        //
        this._saopServicesCore = new SaopServicesCore();
        this.absenceConfirmationPendingView = new SaopAbsenceConfirmationPendingView("", libName +".absenceConfirmationPendingView");
        this.absenceConfirmationPendingView.refreshDataExternal = this.refreshGridData.bind(this);
        this.saopMessageBanner = new SaopMessageBanner();
    }

    refreshGridData(): void {
        global.ConsoleLogDegug("DashboardAbsenceConfirmationView.refreshGridData");
        let _this = this;
        this._saopServicesCore.afterDone = function(response){
            $("#card3 .card-body").html(response);
            _this.absenceConfirmationPendingView.bindGridEvents();
            _this.handleBannerMessages();
        };
        this._saopServicesCore.ExecuteAction({
            action:"Dashboard/AbsenceConfirmationPartial"
            ,type:"GET"
            ,spinnerDivId:"#saopLoadingcard3"
        });   
    }    
    private handleBannerMessages(): void {
        const bannerDiv = $("#hiddenBannerData");
        if (bannerDiv.length > 0) {
            const rawData = bannerDiv.data("banner");
   
            if (rawData && rawData.Messages && rawData.Messages.length) {
                const messages: string[] = [ rawData.Messages.toString() ];
                this.saopMessageBanner.show(messages);
            }
        }
    }
   
    //
}


